import React from "react";
import styled from "styled-components";

const DurationPicker = ({ value, options, onChange }) => {
    const handleCustomChange = (e) => {
        const v = parseInt(e.target.value);
        if (!isNaN(v) && v >= 1) onChange(v);
    };

    return (
        <DurationRow>
            <DurationGroup>
                <DurationGroupLabel>QUICK SELECT DURATION</DurationGroupLabel>
                <QuickPillRow>
                    {options.map((opt) => (
                        <QuickButton
                            key={opt.days}
                            $active={value === opt.days}
                            onClick={() => onChange(opt.days)}
                            type="button"
                        >
                            {opt.label}
                        </QuickButton>
                    ))}
                </QuickPillRow>
            </DurationGroup>
            <DurationGroup>
                <DurationGroupLabel>CUSTOM INTERVAL (DAYS)</DurationGroupLabel>
                <CustomInputBox>
                    <CustomDaysInput
                        type="number"
                        min="1"
                        max="365"
                        value={value}
                        onChange={handleCustomChange}
                        placeholder="00"
                    />
                    <CustomDaysUnit>Days</CustomDaysUnit>
                </CustomInputBox>
            </DurationGroup>
        </DurationRow>
    );
};

export default DurationPicker;

const DurationRow = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 24px;
    flex-wrap: wrap;
`;

const DurationGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const DurationGroupLabel = styled.span`
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #9ca3af;
    text-transform: uppercase;
`;

const QuickPillRow = styled.div`
    display: flex;
    gap: 4px;
    background: #f3f0fa;
    border-radius: 12px;
    padding: 4px;
`;

const QuickButton = styled.button`
    padding: 8px 18px;
    border-radius: 9px;
    border: none;
    background: ${({ $active }) => ($active ? "#fff" : "transparent")};
    color: ${({ $active }) => ($active ? "#9333ea" : "#6b7280")};
    font-size: 14px;
    font-weight: ${({ $active }) => ($active ? "700" : "500")};
    cursor: pointer;
    box-shadow: ${({ $active }) => ($active ? "0 1px 4px rgba(0,0,0,0.10)" : "none")};
    transition: all 0.15s;
    white-space: nowrap;
    &:hover {
        color: #9333ea;
        background: ${({ $active }) => ($active ? "#fff" : "rgba(255,255,255,0.6)")};
    }
`;

const CustomInputBox = styled.div`
    display: flex;
    align-items: center;
    border: 1.5px solid #e5e7eb;
    border-radius: 12px;
    overflow: hidden;
    height: 44px;
    background: #fff;
    &:focus-within {
        border-color: #9333ea;
    }
`;

const CustomDaysInput = styled.input`
    width: 80px;
    padding: 0 14px;
    border: none;
    outline: none;
    font-size: 15px;
    font-weight: 600;
    color: #111827;
    background: transparent;
    text-align: left;
    &::placeholder {
        color: #d1d5db;
        font-weight: 400;
    }
`;

const CustomDaysUnit = styled.span`
    padding: 0 14px 0 0;
    font-size: 14px;
    color: #9ca3af;
    white-space: nowrap;
`;
